import { IStackItemStyles, IStackStyles, getTheme, mergeStyles } from '@fluentui/react';

const palette = getTheme().palette;
export const headerStyles: IStackItemStyles = {
  root: {
    width: '100%'
  }
};
export const containerStyles: IStackStyles = {
  root: {
    height: '100%',
    minHeight: '9.375rem',
    width: '100%',
    overflow: 'hidden'
  }
};
export const containerDarkStyles: IStackStyles = {
    root: {
    height: '100%',
    minHeight: '9.375rem',
    width: '100%',
    overflow: 'hidden',
    background: palette.neutralPrimary
    }
};
export const paneStyles: IStackItemStyles = {
  root: {
    width: '17.875rem'
  }
};
export const overlayStyles: IStackItemStyles = {
  root: {
    background: palette.white,
    marginTop: '4rem',
    zIndex: 2
  }
};
export const hiddenContainerClassName: IStackItemStyles = {
  root: {
    border: `solid 1px ${palette.neutralLighterAlt}`,
    height: '100%',
    display: 'none'
  }
};
export const activeContainerClassName: IStackItemStyles = {
  root: {
    border: `solid 1px ${palette.neutralLighterAlt}`,
    height: 'calc(100% - 3px)',
    display: 'initial',
    width: '100%'
  }
};
export const activeContainerScreenShareClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(100% - 3px)',
        display: 'initial',
        width: '40%'
    }
};

export const activeContainerScreenShareVerticalClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(40% - 3px)',
        display: 'initial',
        width: '100%'
    }
};
export const activeContainerScreenShareVertical34ClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(34% - 3px)',
        display: 'initial',
        width: '100%'
    }
};
export const activeContainerLocalVideoClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(100% - 3px)',
        display: 'initial',
        width: '60%'
    }
};
export const activeContainerLocalVideoVerticalClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(60% - 3px)',
        display: 'initial',
        width: '100%'
    }
};
export const activeContainerLocalVideoVertical66ClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(66% - 3px)',
        display: 'initial',
        width: '100%'
    }
};
export const activeContainer60ClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(100% - 3px)',
        display: 'initial',
        width: '100%',
        maxHeight: '60%'
    }
};
export const activeContainer40ClassName: IStackItemStyles = {
    root: {
        border: `solid 1px ${palette.neutralLighterAlt}`,
        height: 'calc(100% - 3px)',
        display: 'initial',
        width: '100%',
        maxHeight: '40%'
    }
};

export const loadingStyle = mergeStyles({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

export const footerStyle: IStackItemStyles = {
    root: {
        width: '100%',
        height: '4.5rem'
    }
};

export const labelFooterStyle = mergeStyles({
    display: 'flex',
    width: '100%',
    height: '4.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '2em',
    paddingBottom: '40px'
});